import { PointsTab } from '@/modules/common/components/points-tab';
import styles from './index.module.sass';
import { useState } from 'react';
import { useStore } from 'effector-react';
import { $buyerPoints, $buyerPointsLoadingStatus } from '../../store/points.store';
import { deleteBuyerPoint } from '../../functions/delete-buyer-point.function';
import { switchBuyerPoint } from '../../functions/switch-buyer-point.function';
import { createBuyerPoint } from '../../functions/create-buyer-point.function';
import { updateBuyerPoint } from '../../functions/update-buyer-point.function';

export const ReceivingPoints = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const data = useStore($buyerPoints);
  const loadingStatus = useStore($buyerPointsLoadingStatus);

  return (
    <div className={styles.root}>
      <div className={styles.points}>
        <PointsTab
          pointsNotEditable={false}
          loadingStatus={loadingStatus}
          buyerId={0}
          data={data}
          description={'не указан'}
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          customDeleteFoo={deleteBuyerPoint}
          customSwitchFoo={switchBuyerPoint}
          customCreateFoo={createBuyerPoint}
          customUpdateFoo={updateBuyerPoint}
        />
      </div>
    </div>
  );
};
